import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import { makeStyles } from 'tss-react/mui';
import { createTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const useWidth = () => {
  const breakpointValues = {xs: 0, sm: 600, md: 768, lg: 1024, xl: 1440};
  const theme = createTheme({ breakpoints: { values: breakpointValues } });

  theme.breakpoints.values = {xs: 0, sm: 600, md: 768, lg: 1024, xl: 1440};
  const keys = [...theme.breakpoints.keys].reverse();

  return (
    keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || `xs`
  );
}

const useStyles = makeStyles()(() => ({
  heading: {
    marginTop: 16,
  },
}));


const ProductsLoading = ({ isLoading, error }) => {
  const width = useWidth();
  const { classes } = useStyles();

  let height = 293
  switch(width) {
    case `sm`:
      height = 390;
      break;
    case `md`:
    case `lg`:
      height = 504;
      break;
    case `xl`:
      height = 661;
      break;
    default:
      height = 390;
  }

  if (!isLoading) {
    return (
      <>
        <div className="product--banner">
          <div className="background" />
          <div className="background-gradient" />
          <div className="banner--container" />
        </div>
        <div className="product--container">
          <article className="product--data">
            <Skeleton variant="rect" width={432} height={height} className="product--image"/>
            <div className="product--content">
              <div className="product-description">
                <div className="product--heading">
                  <Skeleton variant="rect" width={150} />
                  <Skeleton variant="rect" height={50} className={classes.heading} />
                </div>
                <Skeleton variant="rect" height={300} className="product-description__copy" />
              </div>
            </div>
          </article>
        </div>
      </>
    );
  } else if (error) {
    window.Raven.captureException(error);
    return <div className="loading"><p>Sorry, an error prevented this page from loading.</p></div>;
  }

  return null;
}

ProductsLoading.propTypes = {
  isLoading: PropTypes.bool,
  error: PropTypes.string,
};

export default ProductsLoading;
